import { INotification } from "../common/interfaces/notifications.interface";
import {
  NOTIFICATIONS_URL,
  TOGGLE_NOTIFICATION,
  MARK_ALL,
} from "./utilities/app.urls";
import { get } from "./utilities/http";

/**
 * Get all notifications for user
 * @return {Promise<INotification[]>}
 */
export function getAllNotifications(
  userPubkey: string
): Promise<INotification[]> {
  return get(`${NOTIFICATIONS_URL}/${userPubkey}`);
}

/**
 * Mark notification as read or unread
 * @return {Promise<INotification>}
 */
export function toggleNotification(notificationId: string) {
  return get(`${TOGGLE_NOTIFICATION}/${notificationId}`);
}

/**
 * Mark all notification as read
 * @return {Promise<INotification[]>}
 */
export function markAllNotifications(userPubkey: string) {
  return get(`${MARK_ALL}/${userPubkey}`);
}
